module.exports = __webpack_public_path__ + "static/media/header-1800.b0958d7e.webp";